import { StudentApi, studentsApi } from "api/studentsApi";
import { useEffect, useState } from "react";

export const useStudent = (studentId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<StudentApi | null>(null);

  const fetchStudent = async () => {
    if (!studentId) {
      console.error("Student id not found.");
      setLoading(false);
      return;
    }
    const res = await studentsApi.fetchById(studentId);
    try {
      setData(res.data);
    } catch (error) {
      // Handle error appropriately, perhaps with another state variable
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudent();
  }, [studentId]);

  return { loading, data };
};
